import React, { useEffect, useMemo, useState } from 'react'
import thai from '../../../assets/restaurant/images/thai.png';
import chinese from '../../../assets/restaurant/images/chinese.png';
import english from '../../../assets/restaurant/images/english.png';
import hindi from '../../../assets/restaurant/images/hindi.png';
import japanese from '../../../assets/restaurant/images/japanese.png';
import nepalese from '../../../assets/restaurant/images/nepalese.png';
import logo from '../../../assets/restaurant/images/logo-black.png';
import { useTranslation } from 'react-i18next'
import { getLocalKey, getUserData, logOutRestaurant, setLocalKey } from '../../../utils/commonfunction';
import { Link, NavLink, useLocation } from 'react-router-dom';
import i18next from 'i18next';
import { SOCKET_CLIENT } from '../../../utils/socket';
import defaultUser from '../../../assets/restaurant/images/Avatars.png';
import BellIcon from '../../../assets/restaurant/images/bell.svg';
import { ROLE } from '../../../utils/Constants';
export default function Header() {
  const { t } = useTranslation();
  const [staffUserData, setStaffUserData] = useState({});
  const [flag, setFlag] = useState(getLocalKey("system_language_flag") || english);
  const location = useLocation();

  const changeLanguage = (lang, flag) => {
    i18next.changeLanguage(lang);
    setLocalKey("system_language", lang);
    setLocalKey("system_language_flag", flag);
    setFlag(flag);
    const evt = new CustomEvent("language_change");
    document.dispatchEvent(evt);
  }


  useEffect(() => {
    const userData = getUserData(ROLE.STAFF);
    setStaffUserData(userData)
  }, [])

  const isActive = (url = "/") => {
    return window?.location?.pathname?.includes(url);
  }

  return (
    <div className='header'>
      <nav className="navbar navbar-expand-lg bg-body-tertiary">
        <div className="container-fluid">
          <Link className="navbar-brand"><img src={logo} alt='' /></Link>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <NavLink to={"/staff/create-order"} className="nav-link" aria-current="page"><i className='ti ti-circle-plus'></i>{t("staff.header.nav_link_create_order")}</NavLink>
              </li>
              <li className="nav-item">
                <NavLink to={"/staff/dashboard"} className="nav-link" aria-current="page"><i className="ti ti-home"></i>{t("staff.header.nav_link_home")}</NavLink>
              </li>
              <li className="nav-item">
                <NavLink end to={"/staff/table-management/table/1"} className={"nav-link " + (isActive('/staff/table-management') ? " active" : "")}><i className='ti ti-brand-airtable'></i>{t("staff.header.nav_link_table_management")}</NavLink>
              </li>
              <li className="nav-item">
                <NavLink to={"/staff/sales"} className="nav-link" aria-current="page"><i className='ti ti-chart-bar'></i>{t("staff.header.nav_link_sales")}</NavLink>
              </li>
           
            </ul>
            <div className='d-flex gap-3'>
          
              <div className="dropdown profile-dropdown">
                <button className="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <div className='avatar avatar-xxs'>
                    <img src={staffUserData.profile_image} alt='profile-img' />
                  </div>
                  <span>{staffUserData.first_name}<i className='ti ti-chevron-down'></i></span>
                </button>
                <ul className="dropdown-menu">
                  <div className='profile-drop-head-out'>
                    <div className='profile-drop-head'>
                      <figure className='mx-auto avatar avatar-xs'>
                        <img src={staffUserData.profile_image} alt='profile-img' />
                      </figure>
                      <figcaption>
                        <h4>{staffUserData.first_name}</h4>
                        <p>{staffUserData.email}</p>
                      </figcaption>
                    </div>
                  </div>
                  <li>
                    <Link className="dropdown-item" onClick={(e) => { e.preventDefault(); logOutRestaurant(ROLE.STAFF) }}><i className='ti ti-logout'></i>{t("staff.header.label_logout")}</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  )
}
